module.exports = __webpack_public_path__ + "img/book.100b2304.png";